import { Typography } from 'antd'
import styled from 'styled-components'

const StyledUnknownWordsMatchTypeText = styled(Typography.Text)`
  color: #cccecf;
`

export default StyledUnknownWordsMatchTypeText
